import React from "react";

const pendingDocumentsIcon = () => {
  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        width: "20px",
        height: "15px",
      }}
    >
      {/* Icono principal */}
      <svg
        width="20"
        height="15"
        viewBox="0 0 20 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.08494 15C1.59137 15 1.17959 14.835 0.849587 14.505C0.519587 14.175 0.35423 13.7629 0.353516 13.2686V1.73143C0.353516 1.23786 0.518873 0.826071 0.849587 0.496071C1.1803 0.166071 1.59173 0.000714286 2.08387 0H7.42066L9.56351 2.14286H17.9089C18.4017 2.14286 18.8135 2.30821 19.1442 2.63893C19.4749 2.96964 19.6399 3.38143 19.6392 3.87429V13.2696C19.6392 13.7625 19.4742 14.1743 19.1442 14.505C18.8142 14.8357 18.4024 15.0007 17.9089 15H2.08494Z"
          fill="#30323A"
        />
      </svg>

      {/* Punto rojo de notificación */}
      <svg
        width="6"
        height="6"
        viewBox="0 0 6 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{
          position: "absolute",
          top: "-2px",
          right: "-2px",
        }}
      >
        <path
          d="M3 0C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3C0 3.79565 0.316071 4.55871 0.87868 5.12132C1.44129 5.68393 2.20435 6 3 6C4.665 6 6 4.665 6 3C6 2.20435 5.68393 1.44129 5.12132 0.87868C4.55871 0.316071 3.79565 0 3 0Z"
          fill="#FF0000"
        />
      </svg>
    </div>
  );
};

export default pendingDocumentsIcon;
